<template>
  <div class="accordion" id="accordionExample">
    <div class="accordion-item">
      <button class="accordion-button green-1" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
        <a href="" class="text-decoration-none font-family blue-1 fs-5">ข้อมูลยื่นคำร้อง</a>
      </button>

      <div id="collapseOne" class="accordion-collapse collapse show" aria-labelledby="headingOne"
        data-bs-parent="#accordionExample">

        <div class="list-group">
          <li v-for="item in this.$store.state.ProspectAgentInfo.MenuProspect" :key="item.ReqCodeID"
            class="list-group-item list-group-item-action text-decoration-none font-family fs-5 fw-normal font-menu"
            :class="{ 'font-menu': true }">

            <!-- ยื่นตรวจสอบคุณสมบัติ -->
            <div v-if="item.ReqCodeID === 28" @click="Authentication('/Verification', '', item.ReqCodeID)">
              ยื่นตรวจสอบคุณสมบัติ
              <div class="caret"></div>
            </div>
            <div v-if="item.ReqCodeID === 33" @click="Authentication('/SendAdditionalDoc', '', item.ReqCodeID)">
              ส่งเอกสารเพิ่มเติมยื่นตรวจสอบคุณสมบัติ
              <div class="caret"></div>
            </div>

            <!-- สมัครเป็นตัวแทนกรุงเทพประกันชีวิต -->
            <div v-else-if="item.ReqCodeID === 30" @click="RedirectOnlineAgentRegister()">
              สมัครเป็นตัวแทนกรุงเทพประกันชีวิต
              <div class="caret"></div>
            </div>
            <div v-else-if="item.ReqCodeID === 29" @click="Authentication('/SendAdditionalDoc', '', item.ReqCodeID)">
              ส่งเอกสารเพิ่มเติม(ผู้สมัคร)
              <div class="caret"></div>
            </div>

            <!-- ส่งเอกสารเพิ่มเติมผู้ค้ำประกัน 1 -->
            <div v-else-if="item.ReqCodeID === 34" @click="Authentication('/SendAdditionalDoc', '', item.ReqCodeID)">
              ส่งเอกสารเพิ่มเติมผู้ค้ำประกัน
              <div class="caret"></div>
              <br>
              <h6>{{ item.GuaName }}</h6>
            </div>
            <!-- ส่งเอกสารเพิ่มเติมผู้ค้ำประกัน 2 -->
            <div v-else-if="item.ReqCodeID === 35" @click="Authentication('/SendAdditionalDoc', '', item.ReqCodeID)">
              ส่งเอกสารเพิ่มเติมผู้ค้ำประกัน
              <div class="caret"></div>
              <br>
              <h6>{{ item.GuaName }}</h6>
            </div>

          </li>

        </div>

      </div>
    </div>

    <div class="accordion-item blue-2">
      <router-link to="/ProspectHistory" class="text-decoration-none white">
        <button class="claim-history-menu rounded-bottom font-family fs-5" type="button" data-bs-toggle="collapse"
          data-bs-target="#collapseTwo" style="color: #ffffff">
          <router-view to="/ProspectHistory">ประวัติการแก้ไข</router-view>
          <div class="caret" style="top: 18px; width: 20px; right: 20px; height: 20px"></div>
        </button>
      </router-link>
    </div>
  </div>
</template>

<script>
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js';

export default {
  name: "Menu",
  data() {
    return {

    };
  },
  mounted() {
    if (this.$store.state.USER_NAME == '') {
      this.$router.push('/');
    }

    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/CheckMenuProspect", {
      headers: { Authorization: `Bearer ${AuthorizeToken}` }
    }).then((res) => {
      if (res.status == 200) {
        this.$store.state.ProspectAgentInfo.MenuProspect = res.data;
      }
    });
  },
  methods: {
    Authentication(To, SUBJOB, ReqCodeID) {
      if (SUBJOB === '') {
        this.$store.state.ProspectAgentInfo.CurrentMenuProspect = ReqCodeID;
        this.$router.push(To);
      }
      else {
        // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
        let AuthorizeToken = localStorage.getItem("AuthorizeToken");
        let request = {
          AGENTCODE: [],
          SUBJOB: SUBJOB
        };

        this.$router.push(To);

        http.post("AgencyERequest/CheckCreateJob?", request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
          if (res.data !== '001' && res.data !== '002') {
            this.$router.push(To);
          }
          else {
            Swal.fire({
              icon: 'error',
              html: '<label class="fs-4 fw-normal font-family">ไม่สามารถทำรายการนี้ได้ เนื่องจากมีการร้องของานไปแล้วก่อนหน้า</label>',
            });

            this.$router.push("/ProspectService");
          }

        }).catch((error) => {
          Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดของระบบ</label>',
          });
          this.$router.push("/ProspectService");
        });
      }
    },
    RedirectOnlineAgentRegister() {
      let AuthorizeToken = localStorage.getItem("AuthorizeToken");

      http.get("AgencyERequest/GetOnlineAgentRegisterToken", {
        headers: { Authorization: `Bearer ${AuthorizeToken}` }
      }).then((res) => {
        if (res.status == 200) {
          const targetUrl = `${process.env.VUE_APP_URL_OAR}?auth=${res.data}`;

          window.location.replace(targetUrl);
        }
      });
    }
  },
};
</script>

<style scoped>
.claim-list {
  background-color: #BCD631;
  padding: 0.75rem 1.25rem;
}

.claim-history-menu {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  text-align: left;
  border: 0;
  padding: 1rem 1.25rem;
  background-color: #00AEEF;
}

.caret {
  background-image: url(@/assets/images/arrow-blue.svg);
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 45%;
  width: 16px;
  height: 16px;
  cursor: pointer;
  display: block;
  position: absolute;
  right: 14px;
  top: 12px;
  transition: transform 0.2s ease, -webkit-transform 0.2s ease;
}

.font-menu {
  color: #0058A9;
  cursor: pointer;
}

.font-menu:hover {
  color: #0058A9;
}
</style>